import Vue from 'vue'
import BattleDialog from './src/main'
if (BattleDialog) {
  BattleDialog.install = (options) => {
    if (document.querySelector('.sQDialog')) {
      return
    }
    const AlterBox = Vue.extend(BattleDialog)
    let instance = new AlterBox({
      ...options
    }).$mount()
    document.body.appendChild(instance.$el)
    Vue.nextTick(() => {
      instance.visible = true
      // show 和弹窗组件里的show对应，用于控制显隐
    })
  }
}
export default BattleDialog



// WEBPACK FOOTER //
// ./src/plugin/SQDialog/index.js